import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import { connect } from 'react-redux'

import TextLink from 'components/Luxkit/TextLink'
import BodyText from 'components/Luxkit/Typography/BodyText'
import { getSupportContact } from 'selectors/supportContactSelector'

import SearchTrendingDestinations from 'components/Search/SearchForm/SearchTrendingDestinations'

const Section = styled.div`
  flex-direction: column;
  margin: ${rem(50)} 0 ${rem(50)};
  align-items: center;
`

const MessageBlock = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
`

const Message = styled(BodyText)`
  margin: ${rem(8)} 0;
`

const ContactNumberLink = styled(TextLink)`
  margin-left: ${rem(4)};
`

const TrendingDestinationsSection = styled.div`
  display: flex;
  margin-top: ${rem(40)};
  width: 100%;
`

interface Props {
  currentContact: App.GeoContacts;
}

function HotelSearchNoSearchResultSection({ currentContact }: Props) {
  const localContact = currentContact.local

  return (
    <Section>
      <MessageBlock>
        <Message variant="large">We couldn’t find any offers matching your search</Message>
        <Message variant="large">
          Didn’t find what you were looking for? Speak to one of our travel experts
          <ContactNumberLink href={`tel:${localContact.number}`} rel="nofollow">
            {localContact.humanReadable}
          </ContactNumberLink>
        </Message>
      </MessageBlock>

      <TrendingDestinationsSection>
        <SearchTrendingDestinations />
      </TrendingDestinationsSection>
    </Section>
  )
}

const mapStateToProps = (state: App.State) => ({
  currentContact: getSupportContact(state),
})

export default connect(mapStateToProps)(HotelSearchNoSearchResultSection)
